import React from 'react';
import { industriesAPI } from '../services/api';
import { useAPI } from '../hooks/useAPI';
import { getMockIndustries } from '../data/mockData';
import { useTranslation } from 'react-i18next';

const Industries = () => {
  const { t } = useTranslation();
  const { data: industries, loading, error } = useAPI(industriesAPI.getAll);
  const mockIndustries = getMockIndustries(t);
  const displayIndustries = industries || (error ? mockIndustries : null);

  if (loading) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="text-xl text-gray-600">{t('industries.loading')}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 uppercase tracking-wide mb-4">
            {t('industries.title')}
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-sm sm:text-base">
            {t('industries.description')}
          </p>
        </div>

        {/* Industries List - Clean Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {displayIndustries?.map((industry) => (
            <div key={industry.id} className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md hover:border-blue-200 transition-all duration-300 group">
              <h3 className="text-sm sm:text-base font-semibold text-gray-800 group-hover:text-blue-600 transition-colors text-center">
                {industry.name}
              </h3>
            </div>
          ))}
        </div>

        {/* Additional Industries Text */}
        <div className="mt-8 sm:mt-12 text-center">
          <p className="text-gray-600 mb-4 text-sm sm:text-base">
            {t('industries.additionalText')}
          </p>
          <button className="text-blue-500 hover:text-blue-700 font-semibold text-sm sm:text-base transition-colors">
            {t('industries.contactButton')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Industries;
